import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, FullBox, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
import styles from './APIKeysEmptyState.module.scss';
export const GetAPIKeysEmptyStateTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            APIKeysEmptyStateTID: {
                Root: 'api-keys-empty-state',
                Title: 'api-keys-empty-state-title',
                Description: 'api-keys-empty-state-description',
                ApiDocsLink: 'api-keys-empty-state-api-docs-link',
                KnowledgeBaseLink: 'api-keys-empty-state-knowledge-base-link',
                GenerateKeyButton: 'api-keys-empty-state-generate-key-button'
            }
        }
    });
export const APIKeysEmptyState = (param)=>{
    let { generateKey } = param;
    const { t: apiKeysPageTexts } = useLocaleKeys('settings.apiKeys');
    const { APIKeysEmptyStateTID } = useMemo(()=>GetAPIKeysEmptyStateTID(), []);
    return /*#__PURE__*/ _jsxs(FullBox, {
        className: styles.emptyState,
        testId: APIKeysEmptyStateTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                weight: "normal",
                testId: APIKeysEmptyStateTID.Title(),
                children: apiKeysPageTexts.emptyTitle()
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "paragraph1",
                skin: "secondary",
                testId: APIKeysEmptyStateTID.Description(),
                align: "center",
                style: {
                    width: 800
                },
                children: [
                    apiKeysPageTexts.emptyDescription(),
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        href: "https://docs.sayanchor.com",
                        underline: "none",
                        openInNewTab: true,
                        testId: APIKeysEmptyStateTID.ApiDocsLink(),
                        bi: {
                            name: 'api_keys_empty_state_api_docs_link'
                        },
                        children: apiKeysPageTexts.apiDocumentation()
                    }),
                    apiKeysPageTexts.emptyDescriptionMiddle(),
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        href: "https://intercom.help/anchor-billing/en/articles/12293577-anchor-api-webhooks",
                        underline: "none",
                        openInNewTab: true,
                        testId: APIKeysEmptyStateTID.KnowledgeBaseLink(),
                        bi: {
                            name: 'api_keys_empty_state_knowledge_base_link'
                        },
                        children: apiKeysPageTexts.knowledgeBase()
                    }),
                    apiKeysPageTexts.emptyDescriptionEnd()
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                bi: {
                    name: 'generate_first_api_key'
                },
                onClick: generateKey,
                testId: APIKeysEmptyStateTID.GenerateKeyButton(),
                children: apiKeysPageTexts.generateApiKey()
            })
        ]
    });
};
